type OpenLaunchListener = (opts?: { step?: number }) => void;

const openListeners = new Set<OpenLaunchListener>();

export function openLaunchWizard(opts?: { step?: number }): void {
  for (const fn of openListeners) fn(opts);
}

export function subscribeOpenLaunch(listener: OpenLaunchListener): () => void {
  openListeners.add(listener);
  return () => {
    openListeners.delete(listener);
  };
}
